import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Box, FormControl, InputLabel, Select, MenuItem, Button
} from '@mui/material';

export default function CancellationRuleModal({
    open,
    onClose,
    onSubmit,
    editingRule,
    timeOptions,
    feeOptions,
    formatFeeDisplay
}) {
    const [ruleTimeBefore, setRuleTimeBefore] = useState('');
    const [ruleFee, setRuleFee] = useState('');

    useEffect(() => {
        if (open) {
            setRuleTimeBefore(editingRule?.timeBeforeCheckIn || '');
            setRuleFee(editingRule ? formatFeeDisplay(editingRule) : '');
        }
    }, [open, editingRule, formatFeeDisplay]);

    const handleSave = () => {
        if (!ruleTimeBefore || !ruleFee) return;
        onSubmit(ruleTimeBefore, ruleFee);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontWeight: 'bold' }}>{editingRule ? 'Edit Rule' : 'Add Cancellation Rule'}</DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 1 }}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Time Before Check-in</InputLabel>
                        <Select value={ruleTimeBefore} label="Time Before Check-in" onChange={(e) => setRuleTimeBefore(e.target.value)}>
                            {timeOptions.map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth size="small">
                        <InputLabel>Cancellation Fee</InputLabel>
                        <Select value={ruleFee} label="Cancellation Fee" onChange={(e) => setRuleFee(e.target.value)}>
                            {feeOptions.map(f => <MenuItem key={f} value={f}>{f}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={onClose} color="inherit">Cancel</Button>
                <Button variant="contained" onClick={handleSave} disabled={!ruleTimeBefore || !ruleFee}>
                    {editingRule ? 'Update Rule' : 'Add Rule'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
